import { Suspense } from 'react'
import { Spin } from 'antd'
import { RouterProvider } from 'react-router-dom'
import { router } from './routes'
import { Theme } from '@/configs/theme'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import updateLocale from 'dayjs/plugin/updateLocale'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { queryClient } from './configs/tanstack'
import { QueryClientProvider } from '@tanstack/react-query'
import weekday from 'dayjs/plugin/weekday'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import minMax from 'dayjs/plugin/minMax'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import localeData from 'dayjs/plugin/localeData'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isoWeek from 'dayjs/plugin/isoWeek'
import isBetween from 'dayjs/plugin/isBetween'
import { APIProvider } from '@vis.gl/react-google-maps'
import { ENV } from './constants/env'

import './assets/styles/index.scss'
import { useCheckAppVersion } from './hooks/notification/useCheckAppVersion'
import { sentryErrorAlert } from './configs/sentry'
import i18n from '@/configs/i18n'

import 'dayjs/locale/id'
dayjs.extend(weekOfYear)
dayjs.extend(updateLocale)
dayjs.extend(weekday)
dayjs.extend(utc)
dayjs.extend(timezone)
//
dayjs.extend(minMax)
dayjs.extend(localizedFormat)
dayjs.extend(localeData)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)
dayjs.extend(isBetween)
dayjs.extend(isoWeek)
dayjs.locale(i18n.language)
dayjs.updateLocale(i18n.language, {
  weekStart: 1,
})

sentryErrorAlert.init()
const CheckVersion = () => {
  useCheckAppVersion()
  return null
}
function App() {
  return (
    <Theme>
      <QueryClientProvider client={queryClient}>
        <Suspense
          fallback={
            <div className="fixed grid w-screen h-screen place-items-center">
              <Spin />
            </div>
          }
        >
          <APIProvider apiKey={ENV.VITE_API_KEY_GOOGLE_MAPS_NEW}>
            <GoogleOAuthProvider clientId={ENV.VITE_GOOGLE_CLIENT_ID}>
              <CheckVersion />
              <RouterProvider router={router} />
            </GoogleOAuthProvider>
          </APIProvider>
        </Suspense>
      </QueryClientProvider>
    </Theme>
  )
}

export default App
